import React from 'react';
import cn from 'classnames';

const ListSubtotal = ({
  title,
  content,
  className,
  colTitle,
  colContent,
  nopad,
}) => {
  const c = cn(
    className ? className : '',
    nopad ? '' : 'py-1 mb-1',
    'row flex-wrap list-item m-0 align-items-center'
  );

  return (
    <div className={c}>
      <div className={cn(colTitle ? colTitle : 'fs-5', 'col-5 p-0')}>
        {title}
      </div>
      <div className={cn(colContent ? colContent : 'fs-5 fw-semibold', 'col-7 text-uppercase p-0 text-end title')}>
        {content}
      </div>
    </div>
  );
};

export default ListSubtotal;
